// Pronk Opleidingen v8
(function(){
  // Scroll reveal
  if('IntersectionObserver' in window){
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('visible'); obs.unobserve(e.target); }});
    },{threshold:0.06,rootMargin:'0px 0px -30px 0px'});
    document.querySelectorAll('.reveal').forEach(function(el){ obs.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('visible'); });
  }

  // Mobile nav — met focus-afscherming van de achtergrond (WCAG 2.4.3/2.4.7)
  var _bgHidden = ['main', '.site-footer', '.wa-float', '.topbar'];
  function setBackgroundInert(on){
    _bgHidden.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        if(on){ el.setAttribute('inert',''); el.setAttribute('aria-hidden','true'); }
        else { el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); }
      });
    });
  }
  function closeNav(focusBurger){
    var nav = document.getElementById('MobNav');
    var btn = document.querySelector('.burger');
    if(!nav || !btn) return;
    nav.classList.remove('open'); btn.classList.remove('open');
    btn.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
    setBackgroundInert(false);
    if(focusBurger){ btn.focus(); }
  }
  window.toggleNav = function(){
    var nav = document.getElementById('MobNav');
    var btn = document.querySelector('.burger');
    if(!nav || !btn) return;
    var open = !nav.classList.contains('open');
    if(open){
      nav.classList.add('open'); btn.classList.add('open');
      btn.setAttribute('aria-expanded','true');
      document.body.style.overflow = 'hidden';
      setBackgroundInert(true);
      var first = nav.querySelector('a,button');
      if(first){ first.focus(); }
    } else {
      closeNav(true);
    }
  };
  document.addEventListener('click', function(e){
    var nav = document.getElementById('MobNav');
    var btn = document.querySelector('.burger');
    if(nav && nav.classList.contains('open') && !nav.contains(e.target) && btn && !btn.contains(e.target)){
      closeNav(false);
    }
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){
      var nav = document.getElementById('MobNav');
      if(nav && nav.classList.contains('open')){ closeNav(true); }
    }
  });

  // Dropdown "Opleidingen": houd aria-expanded in sync met hover/focus.
  // De feitelijke zichtbaarheid regelt de CSS (:hover en :focus-within).
  document.querySelectorAll('.has-drop').forEach(function(li){
    var trigger = li.querySelector(':scope > a');
    if(!trigger) return;
    trigger.setAttribute('aria-haspopup','true');
    trigger.setAttribute('aria-expanded','false');
    var sync = function(){ trigger.setAttribute('aria-expanded', String(li.matches(':hover') || li.contains(document.activeElement))); };
    li.addEventListener('mouseenter', sync);
    li.addEventListener('mouseleave', sync);
    li.addEventListener('focusin', sync);
    li.addEventListener('focusout', function(){ setTimeout(sync, 0); });
  });

  // FAQ accordion

  // Escape sluit een geopende nav-dropdown en zet de focus terug op de trigger (WCAG 1.4.13)
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var drop = document.activeElement && document.activeElement.closest ? document.activeElement.closest('.has-drop') : null;
    if (!drop) return;
    var trigger = drop.querySelector(':scope > a');
    drop.classList.add('drop-closed');
    if (trigger) { trigger.focus(); }
    drop.addEventListener('mouseleave', function h(){ drop.classList.remove('drop-closed'); drop.removeEventListener('mouseleave', h); });
    drop.addEventListener('focusout', function h(ev){
      if (!drop.contains(ev.relatedTarget)) { drop.classList.remove('drop-closed'); drop.removeEventListener('focusout', h); }
    });
  });

  window.toggleFaq = function(btn){
    var ans = btn.nextElementSibling;
    var isOpen = ans.classList.contains('open');
    document.querySelectorAll('.faq-ans').forEach(function(a){ a.classList.remove('open'); });
    document.querySelectorAll('.faq-q').forEach(function(b){ b.setAttribute('aria-expanded','false'); });
    if(!isOpen){ ans.classList.add('open'); btn.setAttribute('aria-expanded','true'); }
  };

  // Roving tabindex + pijltjesnavigatie voor elke role=tablist (WCAG ARIA Tabs-patroon)
  function updateRoving(tablist){
    var tabs = tablist.querySelectorAll('[role="tab"]');
    tabs.forEach(function(t){ t.setAttribute('tabindex', t.getAttribute('aria-selected') === 'true' ? '0' : '-1'); });
  }
  document.querySelectorAll('[role="tablist"]').forEach(function(tablist){
    updateRoving(tablist);
    tablist.addEventListener('keydown', function(e){
      var keys = ['ArrowLeft','ArrowRight','Home','End'];
      if(keys.indexOf(e.key) < 0) return;
      var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
      var i = tabs.indexOf(document.activeElement);
      if(i < 0) return;
      e.preventDefault();
      var n;
      if(e.key === 'ArrowRight') n = (i + 1) % tabs.length;
      else if(e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
      else if(e.key === 'Home') n = 0;
      else n = tabs.length - 1;
      tabs[n].focus();
      tabs[n].click();
    });
  });

  // Tarieven tab switcher
  window.switchTarief = function(btn, panelId) {
    var tablist = btn.closest('[role="tablist"]');
    document.querySelectorAll('.tar-tab').forEach(function(t){
      t.classList.remove('active');
      t.setAttribute('aria-selected','false');
    });
    document.querySelectorAll('.tar-panel').forEach(function(p){ p.classList.remove('active'); });
    btn.classList.add('active');
    btn.setAttribute('aria-selected','true');
    if(tablist){ updateRoving(tablist); }
    var panel = document.getElementById(panelId);
    if(panel){
      panel.classList.add('active');
      panel.querySelectorAll('.reveal').forEach(function(el){
        el.classList.remove('visible');
        setTimeout(function(){ el.classList.add('visible'); }, 50);
      });
    }
  };

  // Nested theorie sub-tab switcher (scoped to parent container)
  window.switchTheorie = function(btn, panelId) {
    var container = btn.closest('.th-tabs-wrap');
    if (!container) return;
    container.querySelectorAll('.th-tab').forEach(function(t){
      t.classList.remove('active');
      t.setAttribute('aria-selected','false');
    });
    container.querySelectorAll('.th-panel').forEach(function(p){ p.classList.remove('active'); });
    btn.classList.add('active');
    btn.setAttribute('aria-selected','true');
    var tablist = btn.closest('[role="tablist"]');
    if(tablist){ updateRoving(tablist); }
    var panel = document.getElementById(panelId);
    if(panel){
      panel.classList.add('active');
      panel.querySelectorAll('.reveal').forEach(function(el){
        el.classList.remove('visible');
        setTimeout(function(){ el.classList.add('visible'); }, 50);
      });
    }
  };

  // Cart quantity
  window.cartQty = function(key, delta){
    var inp = document.querySelector('input[name="updates[' + key + ']"]');
    if(inp) inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) + delta);
  };

  // BTW Toggle: PURE WEERGAVESCHAKELAAR particulier (incl.) / bedrijf (excl.)
  // Alle producten hebben een enkele variant met de INCLUSIEF-BTW-prijs als
  // opgeslagen prijs; de winkelinstelling is "alle prijzen zijn inclusief btw".
  // Deze schakelaar wisselt uitsluitend welk bedrag zichtbaar is (CSS-class op
  // <body>). Hij raakt de bestelde variant, de prijs en de links NIET aan:
  // iedereen rekent hetzelfde inclusief-bedrag af.
  window.setBtwMode = function(mode) {
    // Toggle knoppen
    document.querySelectorAll('.btw-opt').forEach(function(b) {
      var isActive = b.dataset.mode === mode;
      b.classList.toggle('active', isActive);
      b.setAttribute('aria-pressed', String(isActive));
    });
    // Body class voor CSS-prijsweergave
    if (mode === 'bedrijf') {
      document.body.classList.add('btw-bedrijf');
    } else {
      document.body.classList.remove('btw-bedrijf');
    }
    // Kondig de wijziging aan voor schermlezers (WCAG 4.1.3)
    var live = document.getElementById('btw-status');
    if(live){ live.textContent = mode === 'bedrijf' ? 'Prijzen worden nu getoond exclusief BTW, voor bedrijven.' : 'Prijzen worden nu getoond inclusief BTW, voor particulieren.'; }
    // Bewaar voorkeur
    try { localStorage.setItem('pronk_btw_mode', mode); } catch(e) {}
  };

  // Init bij laden pagina
  (function() {
    var saved = 'particulier';
    try { saved = localStorage.getItem('pronk_btw_mode') || 'particulier'; } catch(e) {}
    window.setBtwMode(saved);
    // Geen statusmelding bij eerste load
    var live = document.getElementById('btw-status');
    if(live){ live.textContent = ''; }
  })();

  // Theorie bijboeken (productpagina): een gewone form-post kan maar één regel
  // toevoegen. Als de theorie-optie is aangevinkt, onderscheppen we de submit en
  // voegen we pakket + theorie als twee losse regels toe via de Cart AJAX API.
  // Staat er geen theorie-checkbox op de pagina, of is hij niet aangevinkt: gewoon
  // de normale form-submit laten gebeuren (één regel, zoals voorheen). Faalt de
  // fetch, dan valt hij terug op een normale form-submit (dan komt alleen het
  // pakket in de winkelwagen, zonder theorie).
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      var theorieBox = document.getElementById('theorie-addon-check');
      if (!theorieBox || !theorieBox.checked) { return; }

      var variantInput = document.getElementById('variant-id');
      var theorieVariantId = theorieBox.getAttribute('data-theorie-variant-id');
      if (!variantInput || !variantInput.value || !theorieVariantId) { return; }

      e.preventDefault();

      var addUrl = (productForm.getAttribute('action') || '/cart/add') + '.js';
      var cartUrl = productForm.getAttribute('data-cart-url') || '/cart';
      var submitBtn = productForm.querySelector('button[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; }

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: parseInt(variantInput.value, 10), quantity: 1 },
            { id: parseInt(theorieVariantId, 10), quantity: 1 }
          ]
        })
      })
        .then(function (res) {
          if (!res.ok) { throw new Error('cart add failed'); }
          return res.json();
        })
        .then(function () {
          window.location.href = cartUrl;
        })
        .catch(function () {
          // Fallback: normale form-submit (voegt alleen het pakket toe, zonder theorie).
          if (submitBtn) { submitBtn.disabled = false; }
          productForm.submit();
        });
    });
  }
})();
